// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form_Fpass__bj-yQ {
  font-family: Inter, sans-serif;
  font-size: clamp(12px, 1.1vw, 16px);
  font-weight: 400;
  line-height: 1.6;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin-top: clamp(4px, 0.8vh, 10px);
  width: 100%;
}

.login-form_Fpass__bj-yQ a,
.login-form_Fpass__bj-yQ a:visited,
.login-form_Fpass__bj-yQ a:active {
  text-decoration: none;
  color: #DA2612;
  transition: color 0.2s ease;
}

.login-form_Fpass__bj-yQ a:hover {
  text-decoration: underline;
  color: #ff3320;
}

.login-form_error-text__U82f9 {
  color: #ff0000;
  font-size: clamp(0.85rem, 1vw, 1.1rem);
  margin: 0;
  margin-top: clamp(8px, 1.2vh, 16px);
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/features/auth/components/login-form.module.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,mCAAmC;EACnC,WAAW;AACb;;AAEA;;;EAGE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,SAAS;EACT,mCAAmC;EACnC,kBAAkB;AACpB","sourcesContent":[".Fpass {\n  font-family: Inter, sans-serif;\n  font-size: clamp(12px, 1.1vw, 16px);\n  font-weight: 400;\n  line-height: 1.6;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  margin-top: clamp(4px, 0.8vh, 10px);\n  width: 100%;\n}\n\n.Fpass a,\n.Fpass a:visited,\n.Fpass a:active {\n  text-decoration: none;\n  color: #DA2612;\n  transition: color 0.2s ease;\n}\n\n.Fpass a:hover {\n  text-decoration: underline;\n  color: #ff3320;\n}\n\n.error-text {\n  color: #ff0000;\n  font-size: clamp(0.85rem, 1vw, 1.1rem);\n  margin: 0;\n  margin-top: clamp(8px, 1.2vh, 16px);\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Fpass": `login-form_Fpass__bj-yQ`,
	"error-text": `login-form_error-text__U82f9`
};
export default ___CSS_LOADER_EXPORT___;
